<template>
  <div>
  <el-table height="480" style="width: 100%" :data="files">
    <el-table-column type="expand">
      <template slot-scope="props">
        <p>Campaign: {{ props.row.campaign_title }}</p>
        <p>File Type: {{ props.row.file_type }}</p>
        <p>File Size: {{ props.row.size }}</p>
      </template>
    </el-table-column>

    <el-table-column prop="file_name" min-width="420" label="File name">
      <template slot-scope="scope">{{ scope.row.file_name }}</template>
    </el-table-column>

    <el-table-column prop="user_first_name" min-width="180" label="User">
      <template slot-scope="scope">{{ scope.row.user_first_name }}</template>
    </el-table-column>

    <el-table-column prop="date_created" min-width="220" label="Date / Time">
      <template slot-scope="scope">{{ moment(scope.row.date_created).format('ddd Do MMMM YYYY') }}</template>
    </el-table-column>

     <el-table-column prop="user_file" min-width="100">
      <template slot-scope="scope">
         <el-button
          size="mini"
          @click="handleDownload(scope.row.user_file)">
          Download
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'FileboxTable',
  props: {
    files: {
      type: Array,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
  },
  methods: {
    moment,
    getFileIcon(filename) {
      const fileExtension = filename.split('.').pop();
      return this.icons.file[fileExtension];
    },
    handleDownload(fileURL) {
      window.open(fileURL, '_blank');
    },
  },
};
</script>

<style scoped>
.file-icon {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// FileboxTable.vue?339a3686